import styled from "styled-components";

export const Wrapper = styled.div`
  border-radius: ${({ borderRadius }) => borderRadius || 13}px;
  box-sizing: border-box;
  padding: 26px 29px;
  height: 100%;

  display: grid;
  grid-template-columns: ${({ isBig }) =>
    isBig ? "107px minmax(0, 1fr)" : "85px minmax(0, 1fr)"};
  column-gap: 40px;
  align-items: center;

  position: relative;
  overflow: hidden;

  ${({ hasLink }) => hasLink && `cursor: pointer;`}

  &::before {
    position: absolute;
    content: "";
    inset: 0;
    background: ${({ imageUrl }) => `url("${imageUrl}")`};
    background-position: ${({ position }) =>
      position ? `${position.x}% ${position.y}%` : "center"};
    background-size: cover;
    filter: blur(30px) brightness(0.6);
  }
`;

export const ImageDateContainer = styled.div`
  width: 100%;
  position: relative;
  z-index: 1;
`;

export const Image = styled.div`
  width: ${({ isBig }) => (isBig ? "107px" : "85px")};
  height: ${({ isBig }) => (isBig ? "107px" : "85px")};
  border-radius: 50%;
  background: ${({ imageUrl }) => `url("${imageUrl}")`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: ${({ position }) =>
    position ? `${position.x}% ${position.y}%` : "center"};
  box-sizing: border-box;
  padding: 16px;
`;

export const ImageOverlay = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, ${({ opacity }) => opacity});
  inset: 0;
`;

export const Date = styled.div`
  width: ${({ isBig }) => (isBig ? "49px" : "35px")};
  height: ${({ isBig }) => (isBig ? "49px" : "35px")};
  border-radius: ${({ isBig }) => (isBig ? "10.7px" : "8px")};
  background: ${({ bgClr }) => bgClr || "#003BFF"};
  color: ${({ textClr }) => textClr || "#fff"};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: ${({ isBig }) => (isBig ? "12.5px" : "9px")};
  position: absolute;
  top: 0;
  right: ${({ isBig }) => (isBig ? "-22px" : "-15px")};

  .date-day {
    font-size: ${({ isBig }) => (isBig ? "18.27px" : "13px")};
  }
`;

export const TitleTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  z-index: 1;
`;

export const Title = styled.div`
  color: #fff;
  font-size: ${({ isBig, isTemplate }) => {
    if (isTemplate) return "17px";
    return isBig ? "34px" : "22px";
  }};
  line-height: ${({ isBig, isTemplate }) => {
    if (isTemplate) return "19px";
    return isBig ? "34px" : "24px";
  }};
  font-weight: 600;
  position: relative;
  word-break: break-word;
`;

export const TextArrowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  opacity: 0.4;
`;

export const Text = styled.div`
  color: #fff;
  font-size: ${({ isTemplate }) => (isTemplate ? "11px" : "14px")};
  font-weight: 500;
  line-height: ${({ isTemplate }) => (isTemplate ? "14px" : "18px")};
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
